export interface BannerLocalizable {
	url: string;
	firstHeaderName: string;
	headerName: string;
	bodyName: string;
	culture: string;
}

export const defaultBannerLocalizableData: BannerLocalizable[] = [
	{
		url: "",
		firstHeaderName: "",
		headerName: "",
		bodyName: "",
		culture: "tr-TR"
	},
	{
		url: "",
		firstHeaderName: "",
		headerName: "",
		bodyName: "",
		culture: "en-US"
	}
];

export interface DefaultImageList {
	[key: string]: string;
	imageUrl: string;
	smallImageUrl: string;
	mobileImageUrl: string;
}

/* -------------- Operation based interfaces -------------- */

// LIST
export interface BannerListItem {
	bannerId: string;
	displayOrder?: number;
	hasMenu: boolean;
	headerName: string;
	creationDate: string;
}

export interface BannerListApiResponse {
	result: {
		items: BannerListItem[];
	};
	error: string | null;
	isSuccessful: boolean;
}

// GET
export interface BannerDetail {
	bannerId: string;
    imageList: DefaultImageList;
	displayOrder?: number;
	bannerLocalizable: BannerLocalizable[];
}

export interface BannerGetApiResponse {
	result: {
		bannerId: string;
		imageUrl: string;
		smallImageUrl: string;
		mobileImageUrl: string;
		displayOrder?: number;
		bannerLocalizable: BannerLocalizable[];
	}
	error: string | null;
	isSuccessful: boolean;
}

// ORDER
export interface BannerOrderItem {
	bannerId: string;
	displayOrder?: number;
}

// ADD/UPDATE
export interface BannerFormData {
	bannerId?: string;
	image: File | null;
	smallImage: File | null;
	mobileImage: File | null;
	bannerLocalizable: BannerLocalizable[];
}

export const defaultBannerFormData: BannerFormData = {
	bannerId: "",
	image: null,
	smallImage: null,
	mobileImage: null,
	bannerLocalizable: defaultBannerLocalizableData
};

// Page States
export type OperationStatus =
	| { type: "idle" }
	| { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
	| { type: "error"; operation: string; message: string };

